import { Table } from "antd";
import { formateISODateToMoment } from "@/utils";
import ContextMenu from "@/components/containers/ContextMenu";
import BanIcon from "@/icons/BanIcon";
import MarkdownText from "@/components/ui/MarkdownText";

const STATUS_LABELS = {
  registered: "Зарегистрирована",
  completed: "Выполнена",
  cancelled: "Отменена",
};

// Таблица моих заявок
// Содержит список. Тут можно настроить колонки
const MyRequestsTable = ({
  data,
  scroll = { x: 700 },
  loading,
  onChange,
  onCancelRequest,
  onOpenRequest,
}) => {
  const columns = [
    {
      title: "Тип",
      dataIndex: "type",
      key: "type",
      width: 200,
      ellipsis: { showTitle: false },
      sorter: (a, b) => a.form?.name.localeCompare(b.form?.name),
      render: (_, item) =>
        item.form?.name || (
          <div style={{ color: "var(--color-gray-m)" }}>Не указано</div>
        ),
    },
    {
      title: "Номер",
      dataIndex: "task_number",
      key: "task_number",
      ellipsis: {
        showTitle: false,
      },
      width: 80,
      sorter: (a, b) => Number(a.task_number) - Number(b.task_number),
    },
    {
      title: "Дата",
      dataIndex: "created_at",
      key: "created_at",
      ellipsis: {
        showTitle: false,
      },
      defaultSortOrder: "descend",
      width: 100,
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (_, { created_at }) => formateISODateToMoment(created_at),
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
      ellipsis: {
        showTitle: false,
      },
      width: 150,
      sorter: true,
      render: (status) => STATUS_LABELS[status] || "Не указан",
    },
    {
      title: "",
      key: "actions",
      width: 48,
      fixed: "right",
      render: (_, item) =>
        item.status === "completed" || item.status === "cancelled" ? null : (
          <div onClick={(event) => event.stopPropagation()}>
            <ContextMenu
              vertical
              items={[
                {
                  key: "cancel",
                  onClick: () => onCancelRequest?.(item),
                  label: (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <BanIcon style={{ fontSize: 16, color: "#e66a25" }} />
                      Отменить
                    </div>
                  ),
                },
              ]}
            />
          </div>
        ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="uuid"
        loading={loading}
        pagination={false}
        onChange={onChange}
        onRow={(record) => ({
          onClick: () => onOpenRequest?.(record),
          style: onOpenRequest ? { cursor: "pointer" } : undefined,
        })}
        showSorterTooltip={{
          target: "sorter-icon",
          title: "Нажмите для сортировки",
        }}
        scroll={scroll}
        expandable={{
          expandedRowRender: (record) => (
            <MarkdownText value={record.description} />
          ),
          rowExpandable: (record) => !!record.description,
        }}
      />
    </>
  );
};

export default MyRequestsTable;
